module.exports = __webpack_public_path__ + "static/media/back-arrow.ff513a67.svg";